'use client';

import { Flex, Text } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import { CountryCurrency, getCartSummary, getFilteredHalloweenPromoItems, useCartService } from '@skin-seoul/service';
import { LegacyCartIcon } from '../../assets/LegacyCartIcon';
import QueryBoundary from '../../utils/react/QueryBoundary';
import type { Country } from '@skin-seoul/service';
import { ClientOnly } from '@skin-seoul/utils';
const SHOPPING_BAG_BUTTON_TEST_ID = 'shopping-bag-button';
const ProductQuantity = ({
  country
}: {
  country: Country;
}) => {
  const {
    useGetCartSuspenseQuery
  } = useCartService();
  const {
    data
  } = useGetCartSuspenseQuery({
    currency: CountryCurrency[country]
  });
  const {
    items
  } = getCartSummary(data.cart);
  const filteredItems = getFilteredHalloweenPromoItems(items);
  const totalQuantity = filteredItems.reduce((prev, curr) => prev + curr.quantity, 0);
  return <Text textStyle="label.small" color="generic.0" data-sentry-element="Text" data-sentry-component="ProductQuantity" data-sentry-source-file="ShoppingBagButton.tsx">
      {totalQuantity}
    </Text>;
};
type ShoppingBagButtonProps = ComponentProps<typeof Flex> & {
  country: Country;
  iconProps?: ComponentProps<typeof LegacyCartIcon>;
};
const ShoppingBagButton = ({
  country,
  iconProps = {
    color: 'generic.0'
  },
  ...rest
}: ShoppingBagButtonProps) => {
  return <Flex cursor="pointer" data-testid={SHOPPING_BAG_BUTTON_TEST_ID} w="fit-content" h="fit-content" position="relative" {...rest} data-sentry-element="Flex" data-sentry-component="ShoppingBagButton" data-sentry-source-file="ShoppingBagButton.tsx">
      <LegacyCartIcon cursor="pointer" height="24px" width="24px" {...iconProps} data-sentry-element="LegacyCartIcon" data-sentry-source-file="ShoppingBagButton.tsx" />
      <ClientOnly data-sentry-element="ClientOnly" data-sentry-source-file="ShoppingBagButton.tsx">
        <Flex alignItems="center" backgroundColor="#027A48" borderRadius="14px" textStyle="label.small" height="16px" justifyContent="center" position="absolute" right="-4px" top="-4px" width="16px" data-sentry-element="Flex" data-sentry-source-file="ShoppingBagButton.tsx">
          <QueryBoundary loadingFallback={<Text textStyle="label.small" color="generic.0">
                0
              </Text>} errorFallback={<Text textStyle="label.small" color="generic.0">
                0
              </Text>} data-sentry-element="QueryBoundary" data-sentry-source-file="ShoppingBagButton.tsx">
            <ProductQuantity country={country} data-sentry-element="ProductQuantity" data-sentry-source-file="ShoppingBagButton.tsx" />
          </QueryBoundary>
        </Flex>
      </ClientOnly>
    </Flex>;
};
export default ShoppingBagButton;